import {RumTimeMark, sendRumTimeMark} from '@yandex-delivery/modules/rum'
import {applyPolyfills} from '@yandex-delivery/polyfills'
import {raise} from '@yandex-delivery/utils'
import React from 'react'
import {createRoot} from 'react-dom/client'

import App from './App@desktop'

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)

applyPolyfills()
  .then(() => document.getElementById('tariffs_root') || raise('cant find root element "tariffs_root"'))
  .then(createRoot)
  .then(
    root =>
      void root.render(
        <App />
      ),
  )
  .then(() => sendRumTimeMark(RumTimeMark.REACT_INITED))

sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
